"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMixin = void 0;
const IOptions_1 = require("./WrappedProperty/IOptions");
const wrapSchema_1 = require("./WrappedProperty/wrapSchema");
/**
 * liczba przez referencje
 */
exports.schemaMixin = {
    created() {
        const vm = this;
        const schema = vm.$options.schema;
        if (schema && vm.$setSchema) {
            vm.$setSchema(schema, false);
        }
    },
    /*  przeniesione do wrap
    beforeUnmount() {
      (this as VueInterface).$setSchema();
    },
    */
    methods: {
        $setSchema(schema, forceUpdate) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const vm = this;
            if (vm.$schema) {
                vm.$schema.$destroy();
            }
            vm.$schema = vm.schema = undefined;
            if (!schema) {
                return undefined;
            }
            if (vm.model === undefined) {
                throw new Error('no `model` property in data');
            }
            const soptions = {};
            soptions.vm = vm;
            // if (vm.ext)
            if (vm.$options.external) {
                soptions.external = vm.$external = vm.$options.external;
            }
            vm.$form = soptions.form = vm.form || {};
            // const schema2: any = null;
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line: no-console
                console.time('schema fixing time');
            }
            const sopts = vm.schemaOptions || vm.$options.schemaOptions;
            if (sopts && sopts.arrayItemGuidField !== undefined) {
                soptions.arrayItemGuidField = sopts.arrayItemGuidField;
            }
            if (vm.$options.beforeFixSchema) {
                soptions.onBeforeFixSchema = vm.$options.beforeFixSchema;
            }
            if (vm.$options.afterSchema) {
                soptions.onAfterSchema = vm.$options.afterSchema;
            }
            if (vm.$options.beforeSchema) {
                soptions.onBeforeWrap = vm.$options.beforeSchema;
            }
            let extraMethods = undefined;
            // sprawdzenie options
            if (sopts) {
                if (sopts.$methods) {
                    extraMethods = Object.assign(extraMethods || {}, sopts.$methods);
                    sopts.$methods = undefined;
                }
                (0, IOptions_1.mergeOptions)(soptions, sopts);
            }
            if (vm.$options.$methods) {
                extraMethods = Object.assign(extraMethods || {}, vm.$options.$methods);
            }
            if (extraMethods) {
                soptions.schemaMethods = extraMethods;
            }
            const $schema = (0, wrapSchema_1.wrapSchema)(schema, vm.model, soptions);
            // if (vm.model == null) {
            vm.model = $schema.$model;
            vm.$schema = vm.schema = $schema;
            // }
            // Object.seal(vm.$schema);
            if (forceUpdate && vm.$forceUpdate) {
                vm.$forceUpdate();
            }
            return $schema;
        }
    }
};
exports.default = exports.schemaMixin;
//# sourceMappingURL=schemaMixin.js.map